var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-model"},[_c('Affix',{attrs:{"offset-top":_vm.offset_top,"id":"affix"},on:{"on-change":_vm.affixChange}},[_c('div',{ref:"right-nav",staticClass:"data-nav",style:('transform: translateY(' + _vm.translate_y + 'px);')},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }